module.exports = __webpack_public_path__ + "img/20191026151705360截图20191026141929353.4d720f5a.jpg";